import { DlfMatcherTypes } from "../../types/rules/DlfMatcherTypes";
import { DlfMatcher, DlfMatcherProperties } from "./DlfMatcher";

type DefaultValueMatcherData = {
  defaultValue: string;
} & DlfMatcherProperties;

class DefaultValueMatcher
  extends DlfMatcher
  implements DefaultValueMatcherData
{
  discriminator: DlfMatcherTypes = "F_DEFAULT";
  /* DefaultValue Matcher properties */
  defaultValue: string;
  /* Dlf Matcher property */
  fieldName: string;
  /* Matcher properties */
  position: number;
  threshold: number;
  reusable: boolean;
  ocrConfidenceThreshold: number = 1;

  constructor(data: DefaultValueMatcherData) {
    super();
    this.fieldName = data.fieldName;
    this.defaultValue = data.defaultValue;
    this.reusable = data.reusable;
    this.position = data.position;
    this.threshold = data.threshold;
  }
  isConfigured(): boolean {
    return this.defaultValue !== "";
  }

  clear(): void {
    this.defaultValue = "";
  }

  toMatcherData(): DefaultValueMatcherData {
    return {
      ocrConfidenceThreshold: -1,
      discriminator: "F_DEFAULT",
      fieldName: this.fieldName,
      position: this.position,
      defaultValue: this.defaultValue,
      reusable: this.reusable,
      threshold: this.threshold,
    };
  }

  getDiscriminator(): DlfMatcherTypes {
    return this.discriminator;
  }
  getReusable(): boolean {
    return this.reusable;
  }
  setReusable(value: boolean): void {
    this.reusable = value;
  }

  getMatcherId(): string {
    // actively ignore threshold
    return `${this.discriminator}-${this.defaultValue}`;
  }

  static createTest(
    rest: Partial<DefaultValueMatcherData> = {},
  ): DefaultValueMatcher {
    const data: DefaultValueMatcherData = {
      ocrConfidenceThreshold: -1,
      defaultValue: "",
      fieldName: "",
      position: 0,
      reusable: true,
      discriminator: "F_DEFAULT",
      threshold: 0,
    };

    return new DefaultValueMatcher({
      ...data,
      ...rest,
    });
  }
}
export { DefaultValueMatcher, DefaultValueMatcherData };
